import { ERROR_ACTION, WAIT_FOR_ACTION } from 'redux-wait-for-action';

export const actionTypes = {
  ORGANISATION_ITEM_CLEAR: 'ORGANISATION_ITEM_CLEAR',
  ORGANISATION_ITEM_SET: 'ORGANISATION_ITEM_SET',
  ORGANISATION_ITEM_UPDATE: 'ORGANISATION_ITEM_UPDATE',

  ORGANISATION_PATCH_FAILURE: 'ORGANISATION_PATCH_FAILURE',
  ORGANISATION_PATCH_REQUEST: 'ORGANISATION_PATCH_REQUEST',
  ORGANISATION_PATCH_SUCCESS: 'ORGANISATION_PATCH_SUCCESS',

  ORGANISATIONS_GET_FAILURE: 'ORGANISATIONS_GET_FAILURE',
  ORGANISATIONS_GET_REQUEST: 'ORGANISATIONS_GET_REQUEST',
  ORGANISATIONS_GET_SUCCESS: 'ORGANISATIONS_GET_SUCCESS',
};

export const actionCreators = {
  getRequest: () => ({
    type: actionTypes.ORGANISATIONS_GET_REQUEST,
    [WAIT_FOR_ACTION]: actionTypes.ORGANISATIONS_GET_SUCCESS,
    [ERROR_ACTION]: actionTypes.ORGANISATIONS_GET_FAILURE,
  }),
  getSuccess: (organisations: any) => ({
    type: actionTypes.ORGANISATIONS_GET_SUCCESS,
    payload: { ...organisations },
  }),
  getFailure: (error: Error) => ({
    type: actionTypes.ORGANISATIONS_GET_FAILURE,
    error,
  }),

  patchRequest: (organisation: any, logoFile: File, logoAltFile: File) => ({
    type: actionTypes.ORGANISATION_PATCH_REQUEST,
    [WAIT_FOR_ACTION]: actionTypes.ORGANISATION_PATCH_SUCCESS,
    [ERROR_ACTION]: actionTypes.ORGANISATION_PATCH_FAILURE,
    payload: { logoAltFile, logoFile, organisation },
  }),
  patchSuccess: (organisation: any) => ({
    type: actionTypes.ORGANISATION_PATCH_SUCCESS,
    payload: { organisation },
  }),
  patchFailure: (error: Error) => ({
    type: actionTypes.ORGANISATION_PATCH_FAILURE,
    error,
  }),

  itemClear: () => ({
    type: actionTypes.ORGANISATION_ITEM_CLEAR,
  }),
  itemSet: (organisation: any) => ({
    type: actionTypes.ORGANISATION_ITEM_SET,
    payload: { organisation },
  }),
  itemUpdate: (organisation: any) => ({
    type: actionTypes.ORGANISATION_ITEM_UPDATE,
    payload: { organisation },
  }),
};

export default {
  create: actionCreators,
  type: actionTypes,
};
